import {
    Dialog,
    DialogActions,
    DialogContent, DialogTitle,
} from "@mui/material";
import React, {useEffect, useState} from "react";
import TextFieldValidation from "./TextFieldValidation";
import ButtonExit from "../../button/ButtonExit";
import ButtonAdd from "../../button/ButtonAdd";
import MenuItem from "@mui/material/MenuItem";
import UserJobMetricPackingMaterial from "../../../../API/material-cloud/user/UserJobMetricPackingMaterial";

const ModalAddPackaging = ({open, onClose, handleSubmit, initValue, materialId, handleModalAlert,loading}) => {
    const [formState, setFormState] = useState(initValue)
    const [packings, setPackings] = useState([])

    useEffect(() => {
        setFormState(initValue)
        open && UserJobMetricPackingMaterial.getById(materialId)
            .then(function (response) {
                setPackings(response.data)
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    }, [open])

    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: "500px",
                borderRadius: 8,
            }
        }}>
            <DialogTitle
                textAlign="center">{initValue?.packagingMaterialName ? "Изменить упаковку" : "Добавить упаковку"}</DialogTitle>
            <DialogContent>
                <TextFieldValidation
                    select
                    name="packagingMaterialName"
                    label="Упаковка"
                    value={formState?.packagingMaterialName}
                    setCurrValues={setFormState}
                >
                    {packings.map((option) => (
                        <MenuItem key={option.id} value={option.name}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextFieldValidation>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={onClose}/>
                <ButtonAdd
                    loading={loading}
                    text={initValue?.packagingMaterialName ? "Изменить" : "Добавить"}
                           onClick={() => handleSubmit(packings.find(el => el.name === formState?.packagingMaterialName))}/>
            </DialogActions>
        </Dialog>
    );
}
export default ModalAddPackaging